import { DocumentUtils, Utils } from "../../core/utils";
import * as Constants from "../../core/constants";
import Mustache from 'mustache';

export class ScfUserDashboard {
  constructor() {
    Utils.pageSanityHandler();

    this.user_first_name = null;
    this.user_last_name = null;
    this.user_email = null;
    this.user_mobile = null;
    this.user_password = null;
    this.user_password_confirmation = null;
    this.user_permission = null;
    this.user_lender = null;
    this.user_sales_manager=null;

    this.elem_user_first_name = document.getElementById('user_new_first_name');
    this.elem_user_last_name = document.getElementById('user_new_last_name');
    this.elem_user_email = document.getElementById('user_new_email');
    this.elem_user_mobile = document.getElementById('user_new_mobile');
    this.elem_user_password = document.getElementById('user_new_password');
    this.elem_user_password_confirmation = document.getElementById('user_new_password_confirmation');
    this.elem_user_permission =  document.getElementById('user_new_permission');
    this.elem_user_lender = document.getElementById('user_select_lender');
    this.elem_user_sales_manager=document.getElementById('user_select_sales_manager');

    this.elem_user_sales_manager.addEventListener('input', function () {
        Utils.reInput(this);
    });
    this.elem_user_lender.addEventListener('input', function () {
        Utils.reInput(this);
    })
    this.elem_user_first_name.addEventListener('input', function () {
        Utils.reInput(this);
    })
    this.elem_user_last_name.addEventListener('input', function () {
        Utils.reInput(this);
    })
    this.elem_user_email.addEventListener('input', function () {
        Utils.reInput(this);
    })
    this.elem_user_mobile.addEventListener('input', function () {
        Utils.reInput(this);
    })
    this.elem_user_password.addEventListener('input', function () {
        Utils.reInput(this);
    })
    this.elem_user_password_confirmation.addEventListener('input', function () {
        Utils.reInput(this);
    })
    this.elem_user_permission.addEventListener('input', function () {
        Utils.reInput(this);
    })

  }

  setValues(){
  }

  getValues(){
    this.user_first_name = Utils.getter(this.elem_user_first_name);
    this.user_last_name = Utils.getter(this.elem_user_last_name);
    this.user_email = Utils.getter(this.elem_user_email);
    this.user_mobile = Utils.getter(this.elem_user_mobile);
    this.user_password = Utils.getter(this.elem_user_password);
    this.user_password_confirmation = Utils.getter(this.elem_user_password_confirmation);
    this.user_permission = Utils.getter(this.elem_user_permission);
    this.user_lender = Utils.getter(this.elem_user_lender);
    this.user_sales_manager = Utils.getter(this.elem_user_sales_manager);
  }

  validateValues() {
    let pass = true;
    if (!Utils.validatorEmail(this.user_email)) {
        Utils.showInputError(this.elem_user_email, 'Incorrect email address');
        pass = false;
    }
    if (!this.user_first_name) {
        Utils.showInputError(this.elem_user_first_name, 'First Name is mandatory');
        pass = false;
    }
    if (!this.user_last_name) {
        Utils.showInputError(this.elem_user_last_name, 'Last Name is mandatory');
        pass = false;
    }
    if (!this.user_email) {
        Utils.showInputError(this.elem_user_email, 'Email Name is mandatory');
        pass = false;
    }
    if (!this.user_mobile) {
        Utils.showInputError(this.elem_user_mobile, 'Mobile is mandatory');
        pass = false;
    }
    if (!this.user_password) {
        Utils.showInputError(this.elem_user_password, 'Password is mandatory');
        pass = false;
    }
    if (!this.user_password_confirmation) {
        Utils.showInputError(this.elem_user_password_confirmation, 'Password Confirmation is mandatory');
        pass = false;
    }
    if (!this.user_permission) {
        Utils.showInputError(this.elem_user_permission, 'Permission is mandatory');
        pass = false;
    }

    if (this.user_password != this.user_password_confirmation) {
        Utils.showInputError(this.elem_user_password_confirmation, 'Password does not match');
        pass = false;
    }

    if (!Utils.validatorMobile(this.user_mobile)) {
        Utils.showInputError(this.elem_user_mobile, 'Incorrect Mobile Format');
        pass = false;
    }
    if (this.elem_user_permission.value == 'scf_lender') {
        if (!this.user_lender) {
            Utils.showInputError(this.elem_user_lender, 'Lender is mandatory');
            pass = false;
        }
    }
    if(this.elem_user_sales_manager.value=='scf_sales_manager'){
        if(!this.user_sales_manager){
            Utils.showInputError(this.elem_user_sales_manager,'Sales Manager is mandatory');
            pass=false;
        }
    }

    return pass;
}


  handler() {
    this.submitUserDetails();
    this.toggleExtraInputFields();
    this.fillLendersList();
    this.fillSalesManagersList();
  }

  fillLendersList(){
    Utils.requestHandler("/scf/api/lender_application/lenders/all",  Constants.REQUEST.get)
    .then(function (response){
        if(response.message === 'OK'){
          const selectField = document.getElementById('user_select_lender');
          response.data.lenders.forEach(lender => {
            const option = document.createElement('option');
            option.value = lender.id;
            option.text = lender.name;
            selectField.appendChild(option);
          });
        }else{
            Utils.showToast(response.message, Utils.formatErrorMessage(response.errors), Constants.TOAST.fail);
        }
    
    });
  }

  fillSalesManagersList(){
    let body = {
        "params": {},
        "url": Constants.SERVICE_BASE_BACKOFFICE + "/v2/scf/fetch-sales-manager",
        "req_type": "get"
      }
    Utils.requestHandler("/scf/api/application/sales-manager/all", Constants.REQUEST.post, body)
    .then(function (response) {
        if (response.message === 'OK') {
            const selectField = document.getElementById('user_select_sales_manager');
            response.data.forEach(manager => {
                const option = document.createElement('option');
                option.value = manager.id;
                option.text = manager.name;
                selectField.appendChild(option);
            });
        } else {
            Utils.showToast(response.message, Utils.formatErrorMessage(response.errors), Constants.TOAST.fail);
        }
    });
  }

  toggleExtraInputFields() {
    this.elem_user_permission.addEventListener('change', function (event) {
        const lenderElements = document.querySelectorAll(".lender-extra-field");
        const salesManagerElements = document.querySelectorAll(".sales-manager-extra-field");
        if (event.target.value == 'scf_lender') {
            lenderElements.forEach(element => {
                element.classList.remove("no-display");
            });
            salesManagerElements.forEach(element => {
                element.classList.add("no-display");
            });
        } 
        else if (event.target.value == 'scf_sales') {
            salesManagerElements.forEach(element => {
                element.classList.remove("no-display");
            });
            lenderElements.forEach(element => {
                element.classList.add("no-display");
            });
        } 
        else {
            lenderElements.forEach(element => {
                element.classList.add("no-display");
            });
            salesManagerElements.forEach(element => {
                element.classList.add("no-display");
            });
        }
    });
}


  submitUserDetails(){
    let that = this;
    document.getElementById('btn-user-new-submit').addEventListener('click', function(){
      that.getValues();
      if( that.validateValues()){
        let body = {
            first_name: that.user_first_name,
            last_name: that.user_last_name,
            email: that.user_email,
            mobile: that.user_mobile,
            password: that.user_password,
            password_confirmation: that.user_password_confirmation,
            permission: that.user_permission,
            lender_id: that.user_lender,
            sales_manager_id: that.user_sales_manager
        }
        Utils.requestHandler("/scf/api/user/new-user-admin",  Constants.REQUEST.post, body)
        .then(function (response){
            if(response.message === 'OK'){
            Utils.showToast(response.message, 'User details updated', Constants.TOAST.success);
            }else{
            Utils.showToast(response.message, Utils.formatErrorMessage(response.errors), Constants.TOAST.fail);
            }
        
        });
      }
    })
  }


}